<!-- Sidebar shell — siempre oscuro (independiente del tema), colapsa a 0 -->
<div class="h-full bg-gradient-to-b from-[#113E63] to-[#0B283F] flex flex-col overflow-hidden border-r border-white/10 transition-all duration-300"
  [class.w-64]="appMain.sidebarActive || appMain.sidebarStatic"
  [class.w-0]="!appMain.sidebarActive && !appMain.sidebarStatic"
  [class.border-r-0]="!appMain.sidebarActive && !appMain.sidebarStatic"
  (click)="appMain.onSidebarClick($event)">

  <!-- Logo area -->
  <div class="py-4 flex items-center justify-between px-4 border-b border-white/10 flex-shrink-0">
    <a href="/" class="flex items-center gap-2.5 min-w-0">
      @if (appMain.sidebarActive || appMain.sidebarStatic) {
        <img
          [src]="logo"
          alt="Yobing" class="h-12 object-contain" />
      }
      @if (!appMain.sidebarActive && !appMain.sidebarStatic) {
        <img
          src="assets/layout/images/yobing-icon.png"
          alt="Yobing" class="h-12 object-contain"
          onerror="this.style.display='none'" />
      }
    </a>
  </div>

  <!-- Navigation menu -->
  <div class="flex-1 overflow-y-auto py-3 px-3 flex flex-col gap-0.5">
    @for (item of model; track item; let i = $index) {
      <ng-container *ngxPermissionsOnly="item.roles">
        @if (checkProfile(item.profiles)) {
          <!-- Separator -->
          @if (item.separator) {
            <div
              class="my-2 border-t border-white/10 mx-1">
            </div>
          }
          <!-- Menu item -->
          @if (!item.separator && item.show) {
            <li app-menuitem
              [item]="item"
              [index]="i"
              [root]="true"
              class="list-none">
            </li>
          }
        }
      </ng-container>
    }
  </div>

</div>
